import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class IssueContainerQueryCriteriaClass extends BaseCriteriaModel {
  // hdr
  guid_parent?: Optional<string> = Optional.empty();
  title?: Optional<string> = Optional.empty();
  issue_key?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  updated_date_from?: Optional<string> = Optional.empty();
  updated_date_to?: Optional<string> = Optional.empty();
  main_assignee?: Optional<string> = Optional.empty();
  main_reporter?: Optional<string> = Optional.empty();
  issue_type_guid?: Optional<string> = Optional.empty();

  //ext
  hdr_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
}

export class IssueContainerCriteriaModelQuery {
  query = '';

  constructor(issueContainerCriteriaModel: IssueContainerQueryCriteriaClass) {

    if (!issueContainerCriteriaModel) {
      return;
    }

    this.query += issueContainerCriteriaModel.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += issueContainerCriteriaModel.title.filter(x => x !== '').map(x => '&title=' + x).orElse('');
    this.query += issueContainerCriteriaModel.issue_key.filter(x => x !== '').map(x => '&issue_key=' + x).orElse('');
    this.query += issueContainerCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += issueContainerCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += issueContainerCriteriaModel.updated_date_from.filter(x => x !== '').map(x => '&updated_date_from=' + x).orElse('');
    this.query += issueContainerCriteriaModel.updated_date_to.filter(x => x !== '').map(x => '&updated_date_to=' + x).orElse('');
    this.query += issueContainerCriteriaModel.main_assignee.filter(x => x !== '').map(x => '&main_assignee=' + x).orElse('');
    this.query += issueContainerCriteriaModel.issue_type_guid.filter(x => x !== '').map(x => '&issue_type_guid=' + x).orElse('');
    this.query += issueContainerCriteriaModel.main_reporter.filter(x => x !== '').map(x => '&main_reporter=' + x).orElse('');

    this.query += issueContainerCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += issueContainerCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += issueContainerCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += issueContainerCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += issueContainerCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += issueContainerCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += issueContainerCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += issueContainerCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');


    this.query += '&status=' + issueContainerCriteriaModel.status;
    this.query += '&orderBy=' + issueContainerCriteriaModel.orderBy;
    this.query += '&order=' + issueContainerCriteriaModel.order;
    this.query += '&offset=' + issueContainerCriteriaModel.offset + '&limit=' + issueContainerCriteriaModel.limit;
  }
}
